<template>
  <div class="about-container" :class="{'in-modal': inModal}">
    <div class="about-image" v-if="inModal">
      <div class="about-content">
        <img :src="require('@/assets/tpbf/TPBF-logo-white.png')" alt="" class="logo-body">
      </div>
    </div>
    <div class="about-image" v-else>
      <div class="about-content">
        <img :src="require('@/assets/tpbf/TPBF-logo-body.png')" alt="" class="logo-body">
      </div>
      <img :src="require('@/assets/tpbf/TPBF-body.png')" alt="" class="body">
    </div>
  </div>
</template>
<script>
export default {
  name: "LoginBanner",
  props: {
    inModal: {
      type: Boolean,
      default: false,
    }
  },
}
</script>
<style scoped lang="scss">
.about-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 0;
  position: relative;
  z-index: 0;
  .about-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    font-weight: 600;
    color: $banner-color;
    padding-block: 48px;
    aspect-ratio: inherit;
    z-index: 1;
    width: 100%;
    label {
      font-size: 24px;
      text-transform: uppercase;
    }
    img {
      width: auto !important;
      max-height: 120px;
      flex: 1;
    }
    button {
      cursor: pointer;
      border: none;
      border-radius: 24px;
      padding: 4px 12px;
      background: $banner-color;
      color: $white;
      font-weight: 600;
      margin-top: 16px;
    }
  }
  .about-image {
    padding-inline: 24px;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    img {
      &.body {
        position: absolute;
        min-width: 150%;
        object-fit: cover;
        top: -5%;
        left: -25%;
        z-index: 0;
        opacity: 0.3;
      }
      &.logo-body {
        flex: 1;
        z-index: 1;
        height: 100px;
        max-width: 350px;
        object-fit: contain;
      }
    }
  }
  &:is(.in-modal){
    background-color: $banner-color;
  }
}

@media (min-width: 672px) {
  .about-container:not(.in-modal) {
    .about-image{
      padding-inline: 4% !important;
      img {
        &.body {
          position: absolute;
          min-width: 120%;
          width: 120%;
          object-fit: contain;
          top: -15%;
          left: 10%;
          opacity: 1 !important;
        }
      }
      .about-content {
        img {
          max-height: 250px;
        }
      }
    }
  }
}
@media (min-width: 671px) and (max-width: 768px) {
  .about-container:not(.in-modal){
    .about-image {
      .about-content {
        img {
          max-height: 120px !important;
        }
      }
      .about-image {
        img {
          &.body {
            position: absolute;
            min-width: 100% !important;
            width: 100% !important;
            object-fit: contain;
            top: -15%;
            left: 10%;
            opacity: 1 !important;
          }
          &.logo-body {
            height: 90px;
            max-width: 200px;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>